<template>
  <div class="subscription_page">
    <h1>订阅报表</h1>
    <div class="user-options clearfix">
      <el-select style="width: 160px" v-model="curChannel.selectValue" placeholder="">
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <DatePicker2 @datePickedChange="datePickedChange"></DatePicker2>
      <el-button type="primary" @click="doInquery">查询</el-button>
      <el-button type="primary" @click="downloadReport">下载</el-button>
    </div>
    <div class="display-type">
      <div v-loading="loading">
        <CustomTable
          :tableList="tableList"
          :options="tableOptions"
          class="table"
        ></CustomTable>
      </div>
    </div>
  </div>
</template>

<script>
import CustomTable from "../../components/CustomTable";
import DatePicker2 from "../../components/DatePicker2";

export default {
  components: {
    CustomTable,
    DatePicker2,
  },
  data() {
    return {
      curChannel: {
        selectValue: "total",
        content: "",
      },
      channels: this.$store.state.channels,
      datePicked: [
        this.$store.getters.dateTwoDayBefore,
        this.$store.getters.dateOneDayBefore,
      ],
      tableOptions: {
        defaultSort: {
          prop: "date",
          order: "ascending",
        },
        theader: [
          {
            name: "date",
            label: "日期",
            sortable: true,
            fixed: true,
            width: "180px",
          },
          {
            name: "channel",
            label: "平台",
            sortable: true,
            fix: true,
            width: "180px",
          },
          {
            name: "dau",
            label: "dau",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "totalRecharge",
            label: "总收入(包含订阅)",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "subscriptionPrice",
            label: "订阅总收入",
            sortable: true,
            fix: true,
            width: "150px",
          },

          {
            name: "cumulativeCount",
            label: "累积订阅次数",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "totalCount",
            label: "当日总订阅次数",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "cumulativeRenewCount",
            label: "累积续订次数",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "renewCount",
            label: "当日续订次数",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "aCount",
            label: "A档订阅次数",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "bCount",
            label: "B档订阅次数",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "cCount",
            label: "S档订阅次数",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "dCount",
            label: "C档订阅次数",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "cancelCount",
            label: "取消订阅次数",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "newUserCount",
            label: "新增用户数",
            sortable: true,
            fix: true,
            width: "150px",
          },
          {
            name: "newOneDayCount",
            label: "新增用户当天订阅次数",
            sortable: true,
            fix: true,
            width: "190px",
          },
          {
            name: "newTwoDayCount",
            label: "新增用户次日订阅次数",
            sortable: true,
            fix: true,
            width: "240px",
          },
          {
            name: "newThreeDayCount",
            label: "新增用户3日订阅次数",
            sortable: true,
            fix: true,
            width: "240px",
          },
          {
            name: "newAfterThreeDayCount",
            label: "新增用户3日以后订阅次数",
            sortable: true,
            fix: true,
            width: "240px",
          },
          {
            name: "calCancelCount",
            label: "累计取消订阅",
            sortable: true,
            fix: true,
            width: "240px",
          },
          {
            name: "effectiveCount",
            label: "当前生效订阅",
            sortable: true,
            fix: true,
            width: "240px",
          },
        ],
      },
      tableList: [],
      loading: true,
    };
  },
  beforeCreate() {},
  created() {
    this.getList();
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username;
    },
    userLevel() {
      return this.$store.getters.userLevel;
    },
    token() {
      return this.$store.getters.token;
    },
  },
  watch: {},
  methods: {
    datePickedChange(date) {
      this.datePicked = date;
    },
    //获取视频通话数据
    getList() {
      this.loading = true;
      this.$axios({
        type: "GET",
        url: this.$store.getters.path.reports_subscription,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
          start: this.datePicked[0],
          end: this.datePicked[1],
          channel: this.curChannel.selectValue,
        },
      })
        .then(
          (res) => {
            if (res.data.code === 0) {
              this.tableListBuild(res.data.data);
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
              this.$router.push(this.$route.query.redirect || "/login");
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          },
          (err) => {
            this.$message({
              showClose: true,
              message: "请求错误:" + err,
              type: "error",
            });
          }
        )
        .then(() => {
          this.loading = false;
        });
    },
    //表格数据
    tableListBuild(data) {
      this.tableList = data;
    },
    doInquery() {
      this.getList();
    },
    // 生成并下载主播excel
    downloadReport() {
      window.location.href =
        this.$store.getters.path.reports_download_subscription +
        "?token=" +
        this.token +
        "&start=" +
        this.datePicked[0] +
        "&end=" +
        this.datePicked[1] +
        "&channel=" +
        this.curChannel.selectValue +
        "&username=" +
        this.username;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.subscription_page {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;
  }
}
</style>
